import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { StringHelper } from 'src/app/directives/string-helper';
import { MinimumWordCountValidator } from 'src/app/directives/minimum-word-count-validator.directive';
import { DossierService } from 'src/app/services/dossier.service';
import { Observable, catchError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { LoggingService } from 'src/app/services/logging.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'src/app/services/toast.service';
import { RequestApiClient } from 'src/app/services/api-clients/request.apiclient';

export const DeleteRequestModalOptions: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  centered: true,
  size: 'md'
};

@Component({
    templateUrl: './delete-request.modal.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteRequestModal {

  @Input() selectedRequestIds: string[] = [];
  @Output() deleteItems = new EventEmitter();
  translations = <any>{};

  get multipleRequests(): boolean {
    return this.selectedRequestIds.length > 1;
  }

  constructor(private activeModal: NgbActiveModal, private requestService: RequestApiClient, private loggingService: LoggingService, private translateService: TranslateService, private toastService: ToastService) {
    this.getTranslations()
  }

  public closeModal() {
    this.activeModal.close();
  }

  public TriggerDelete() {
    this.DeleteRequests();
  }

  private DeleteRequests() {
    for (const request of this.selectedRequestIds) {
      try {
        this.requestService.deleteRequest(request).subscribe(() => {
          this.toastService.showSuccess(this.translations.success, this.translations.toastsRequestDeleted);
        });
      } catch (error: any) {
        this.handleError(error)
      }
    };
    this.deleteItems.emit();
    this.closeModal();
  }

  private getTranslations() {
    this.translateService.get([
      'Toasts.Success',
      'Toasts.RequestDeleted',
      'Toasts.DeleteError',
      'Toasts.Error',
    ]).subscribe(translation => {
      this.translations.success = translation['Toasts.Success'];
      this.translations.toastsRequestDeleted = translation['Toasts.RequestDeleted'];
      this.translations.DeleteError = translation['Toasts.DeleteError'];
      this.translations.error = translation['Toasts.Error'];
    });
  }
  private handleError(error: HttpErrorResponse): Observable<never> {
    this.loggingService.logException(error);
    this.toastService.showError(this.translations.error, this.translations.DeleteError);
    this.closeModal();
    // Return an observable without an error, needed for the PIPE
    return new Observable<never>();
  }
}

